<template>
  <div>
      <div class="location_css">
      <img src="../../assets/img/location.png" />
      <div>当前位置：</div>
      <div @click="goSy()">首页</div>
      <div><i class="el-icon-arrow-right"></i></div>
      <div class="location_text">精品展示</div>
    </div>
    <el-row v-loading="loading" style="min-height:400px">
      <el-col
      
      style="padding:15px;cursor:pointer;"
        :span="6"
        v-for="(item, index) in list"
        :key="index"
        
      >
        <el-card :body-style="{ padding: '0px' }" @click.native="goDetail(item)">
          <img
            :src="item.wineImage"
            class="image"
          />
          <div style="padding: 14px;">
            <span>{{item.wineName}}</span>
            <div class="bottom clearfix">
              <div style="margin-bottom:10px" class="time">{{item.restaurantName}}</div>
              <div class="time" style="color:#D92208">{{item.winePrice}}</div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <div style="padding-top:10px;padding-bottom:15px;text-align:center;">
        <el-pagination
            background
            layout="total, prev, pager, next"
            :current-page="pageNum"
            :page-size="pageSize"
            :total="total"
            @current-change="pageChange"
          ></el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
        loading:false,
        list:[],
        pageNum:1,
        total:0,
        pageSize:8,
    };
  },
  methods:{
    goSy(){
        this.$router.push({
            path:"/home"
        });
      },
    goDetail(data){
        this.$router.push({
                path: "/goodsdetail?id="+data.wineId,
            })
    },
      //翻页
    pageChange(page) {
      this.pageNum = page;
      this.getDataList();
    },
      getDataList(){
          let vue = this;
          vue.loading = true;
            this.$axios.get("fx-web/wine/page/wine", { params: { pageNum: vue.pageNum, pageSize: vue.pageSize } }).then(function(resp) {
                if (resp.errcode == 0 || resp.errcode == "0") {
                    vue.list = resp.data.dataList;
                    vue.total = resp.data.totalRow;
                } else {
                    vue.$message.warning(resp.errtext);
                };
                vue.loading = false;
            }, function() {
                vue.loading = false;
            });
      }
  },
  mounted(){
      this.getDataList();
  }
};
</script>
<style lang="scss" scoped>
::v-deep{
    .image{
        height: 340px;
    }
}
  .time {
    font-size: 13px;
    color: #999;
  }
  
  .bottom {
    margin-top: 13px;
    line-height: 12px;
  }

  .button {
    padding: 0;
    float: right;
  }

  .image {
    width: 100%;
    display: block;
  }

  .clearfix:before,
  .clearfix:after {
      display: table;
      content: "";
  }
  
  .clearfix:after {
      clear: both
  }
</style>
